var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-7.82 0 58.04 58.04",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(-287.105 -437.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M326.2,447.871h-35.79a2.008,2.008,0,0,0-2.008,2.008v42.763a2.008,2.008,0,0,0,2.008,2.008H326.2a2.009,2.009,0,0,0,2.008-2.009v-6.68h0V449.879A2.007,2.007,0,0,0,326.2,447.871Z",
    fill: "#ffffff",
    stroke: "#505873",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.592
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M308.3,455.065",
    fill: "#ffffff",
    stroke: "#505873",
    strokeMiterlimit: 10,
    strokeWidth: 2.592
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M308.3,455.065",
    fill: "#ffffff",
    stroke: "#505873",
    strokeMiterlimit: 10,
    strokeWidth: 2.592
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M312.94,464.3a4.641,4.641,0,0,0-4.621,4.248.017.017,0,0,1-.033,0,4.641,4.641,0,0,0-5.065-4.227,4.829,4.829,0,0,0-4.171,5.291c.194,2.273,1.4,4.252,3.923,6.559,2.046,1.874,5.061,4.3,5.256,4.459a.014.014,0,0,0,.019,0c.2-.157,3.715-2.946,5.384-4.46,2.28-2.068,3.577-4.059,3.881-6.223A4.819,4.819,0,0,0,312.94,464.3Z",
    fill: "#ffffff",
    stroke: "#505873",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M312.06,444.646v-1.77a3.673,3.673,0,1,0-7.347,0v1.77h-7.732V451.9h22.81v-7.257Z",
    fill: "#ffffff",
    stroke: "#505873",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.592
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/health-icon.83b9f1aed052ee7d206984df0a332607.svg";
export { ForwardRef as ReactComponent };